interface Radius {
  sm: string;
  md: string;
  lg: string;
  xl: string;
}

declare module '@mui/material/styles' {
  interface Theme {
    radius: Radius;
  }

  // allow configuration using `createTheme`
  interface ThemeOptions {
    radius?: Radius;
  }
}

const radius = {
  radius: {
    sm: '5px',
    md: '7px',
    lg: '16px',
    xl: '24px',
  },
};

export default radius;
